import React, { useContext } from 'react';
import classNames from 'classnames';
import { FILTER } from '@fiverr-private/listing_lib';
import { AppContext } from '../../../../../context/listingsContext';
import { getFilterById } from '../../../../util';
import BusinessProToggle from './business_pro_toggle';
import ProToggle from './pro_toggle';
import SellerOnlineToggle from './seller_online_toggle';
import { toggleFiltersStyles } from './toggleFilters.ve.css';
import { PersonalAssistantToggle } from './personal_assistant_toggle';

const ToggleFilters = ({ filters }) => {
    const {
        isBusiness,
        inCaterpillarsToggleRemovalTestWithProRemoved,
        userData: { inShowOnlineToggleList } = {},
        inOwlsSideFiltersTest,
    } = useContext(AppContext);

    const ContextualToggle = () => {
        if (isBusiness) {
            return <BusinessProToggle {...getFilterById(filters, FILTER.PRO.ID)} source="toggle_filters" />;
        } else if (!inCaterpillarsToggleRemovalTestWithProRemoved) {
            return <ProToggle tooltip filter={getFilterById(filters, FILTER.PRO.ID)} source="toggle_filters" />;
        }

        return null;
    };

    return (
        <div
            className={classNames('togglers-wrapper', 'flex', 'flex-items-baseline', {
                [toggleFiltersStyles]: inOwlsSideFiltersTest,
            })}
        >
            <ContextualToggle />
            <PersonalAssistantToggle
                tooltip
                filter={getFilterById(filters, FILTER.PERSONAL_ASSISTANT.ID)}
                source="toggle_filters"
            />
            {inShowOnlineToggleList && (
                <SellerOnlineToggle
                    tooltip
                    filter={getFilterById(filters, FILTER.IS_SELLER_ONLINE.ID)}
                    source="toggle_filters"
                />
            )}
        </div>
    );
};

export default ToggleFilters;
